import { createSelector } from 'reselect';

export const consolidationsSelector = (state) => state.consolidations;
const subsidiaryIdsSelector = (state) => state.consolidations.subsidiaryIds;
const subsidiariesByIdSelector = (state) =>
  state.consolidations.subsidiariesById;

export const subsidiariesSelector = createSelector(
  subsidiaryIdsSelector,
  subsidiariesByIdSelector,
  (subsidiaryIds, subsidiariesById) => {
    return subsidiaryIds.map((id) => ({
      id: parseInt(id, 10),
      ...subsidiariesById[id],
    }));
  }
);
